/**
 * Static content for the DRHP & IPO Prospectus Tracker (/drhp-filings): the
 * offer-document lifecycle, the DRHP checklist and FAQs. General regulatory
 * guidance only; the filings themselves come from the API.
 */

export const LIFECYCLE_STAGES = [
  {
    stage: 'Stage 01',
    title: 'Draft RHP (DRHP)',
    body: 'Filed with SEBI and the stock exchanges (or with the exchange alone for SME issues) and published for public comments. It carries the business, financials, risks and use of proceeds, but no price.',
    footLabel: 'Public comments',
    footValue: '21 days',
  },
  {
    stage: 'Stage 02',
    title: 'SEBI Observations',
    body: 'SEBI reviews the draft, raises queries with the lead managers and issues its observations. The company updates the document to address them.',
    footLabel: 'Validity',
    footValue: '12 months to open the issue',
  },
  {
    stage: 'Stage 03',
    title: 'Red Herring (RHP)',
    body: 'Filed with the Registrar of Companies before the issue opens. It has everything except the final price: the price band, lot size and bidding dates are announced alongside it.',
    footLabel: 'Price band',
    footValue: '2 working days before opening',
  },
  {
    stage: 'Stage 04',
    title: 'Final Prospectus',
    body: 'Filed with the Registrar of Companies after bidding closes, with the final issue price and the number of shares allotted.',
    footLabel: 'Listing',
    footValue: 'T+3 working days',
  },
];

export const DRHP_CHECKLIST = [
  { title: 'Promoter background & litigation', body: 'Outstanding criminal, tax or regulatory cases against the company and its promoters.' },
  { title: 'Objects of the issue', body: 'How much is fresh capital for the business versus an offer for sale that goes to selling shareholders.' },
  { title: 'Restated financials', body: 'Revenue and profit trends, EBITDA margins, debt and cash flow from operations across the restated years.' },
  { title: 'Top risk factors', body: 'Customer or supplier concentration, pending approvals, contingent liabilities and dependence on key people.' },
  { title: 'Peer valuation', body: 'How the issue price compares with listed peers on P/E, return on net worth and margins.' },
];

export const DRHP_FAQS = [
  {
    question: 'What is an offer document in an IPO?',
    answer:
      'The legal document through which a company invites the public to buy its shares. It covers the business, promoters, restated financials, risk factors, objects of the issue and the offer structure. It starts as the Draft Red Herring Prospectus (DRHP), becomes the Red Herring Prospectus (RHP) before bidding and ends as the final Prospectus after the price is fixed.',
  },
  {
    question: 'What is a red herring prospectus in an IPO?',
    answer:
      'The RHP is the offer document filed with the Registrar of Companies before the issue opens. It contains everything investors need to bid except the final price and the exact number of shares, because those are decided through book building. The price band and bidding dates are announced along with it.',
  },
  {
    question: 'What is the difference between a DRHP and a prospectus?',
    answer:
      'The DRHP is the first draft, filed with SEBI and the exchanges for review and public comments. The final Prospectus is filed after bidding closes and includes the final issue price and allotment details. In between, the RHP updates the draft with SEBI’s observations and the price band.',
  },
  {
    question: 'Who prepares an IPO prospectus?',
    answer:
      'The company prepares it with its book running lead managers (merchant bankers), legal counsel and statutory auditors. The lead managers carry out due diligence and are responsible for the disclosures under SEBI’s ICDR Regulations, 2018.',
  },
  {
    question: 'What should I look for in an IPO prospectus?',
    answer:
      'Start with the objects of the issue, the restated financials, the risk factors, outstanding litigation and the basis for the issue price against listed peers. Then check promoter shareholding before and after the issue, and how much of the offer is fresh capital versus an offer for sale.',
  },
];
